import { Badge } from '@mantine/core'

import type { RunStatus, TraceStatus } from '../types'

const runStatusColor: Record<RunStatus, string> = {
  running: 'blue',
  completed: 'green',
  failed: 'red',
}

const traceStatusColor: Record<TraceStatus, string> = {
  in_progress: 'blue',
  done: 'green',
  failed: 'red',
}

export const RunStatusBadge = ({ status }: { status: RunStatus }) => (
  <Badge color={runStatusColor[status]} variant='light' tt='uppercase'>
    {status}
  </Badge>
)

export const TraceStatusBadge = ({ status }: { status: TraceStatus }) => (
  <Badge color={traceStatusColor[status]} variant='light' tt='uppercase'>
    {status.replace('_', ' ')}
  </Badge>
)

export const ActionBadge = ({ action }: { action?: string | null }) => {
  if (!action) {
    return (
      <Badge color='gray' variant='outline'>
        none
      </Badge>
    )
  }
  const color =
    action === 'DELETE'
      ? 'red'
      : action === 'MERGE'
        ? 'violet'
        : action === 'UPDATE_URL'
          ? 'cyan'
          : action === 'FLAG_FOR_REVIEW'
            ? 'orange'
            : 'blue'
  return (
    <Badge color={color} variant='light'>
      {action}
    </Badge>
  )
}

export const PhaseBadge = ({ phase }: { phase: string }) => (
  <Badge color='gray' variant='dot' size='sm'>
    {phase}
  </Badge>
)

export const HubSpotExecutionBadge = ({
  lastEvent,
  lastError,
}: {
  lastEvent: string
  lastError?: string | null
}) => {
  if (['group_skipped', 'company_absent'].includes(lastEvent)) {
    return (
      <Badge color='gray' variant='light' title={lastError ?? undefined}>
        Skipped
      </Badge>
    )
  }
  if (
    [
      'company_merged',
      'company_deleted',
      'company_domain_updated',
      'review_task_created',
      'hubspot_batch_flushed',
    ].includes(lastEvent)
  ) {
    return (
      <Badge color='green' variant='light'>
        HubSpot done
      </Badge>
    )
  }
  if (lastEvent === 'hubspot_failed') {
    return (
      <Badge color='red' variant='light' title={lastError ?? undefined}>
        HubSpot failed
      </Badge>
    )
  }
  if (lastEvent === 'hubspot_started') {
    return (
      <Badge color='blue' variant='light'>
        HubSpot running
      </Badge>
    )
  }
  return (
    <Badge color='gray' variant='outline'>
      Pending
    </Badge>
  )
}
